import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px'
};

const toggle: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '2px',
  alignSelf: 'flex-start',
  padding: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  textDecoration: 'none',
  '&:hover': { textDecoration: 'none' }
};

const summary: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '15px'
};

const chevron: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '18px'
};

const list: SxProps<Theme> = {
  gap: '2px',
  paddingLeft: '4px'
};

const listItem: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '14px'
};

export const candidateProfileFilterNoticeSx = {
  container,
  toggle,
  summary,
  chevron,
  list,
  listItem
};
